export default __webpack_public_path__ + "static/media/form.064ca9fd.jpg";